import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const Drawings: Portfolio = {
    path: "drawings",
    name: "Drawings",
    pageStyle: PageStyle.Gray,
    pieces: [
        {image: "drawings-01.jpg", thumbAlt: "air lines", title: "Drawings 1", size: "22 \u00d7 30", pixelWidth: 399, pixelHeight: 360},
        {image: "drawings-02.jpg", thumbAlt: "air lines", title: "Drawings 2", size: "22 \u00d7 30", pixelWidth: 357, pixelHeight: 360},
        {image: "drawings-03.jpg", thumbAlt: "fire lines", title: "Drawings 3", size: "22 \u00d7 30", pixelWidth: 351, pixelHeight: 360},
        {image: "drawings-04.jpg", thumbAlt: "fire lines", title: "Drawings 4", size: "22 \u00d7 30", pixelWidth: 360, pixelHeight: 360},
        {image: "drawings-05.jpg", thumbAlt: "fire lines", title: "Drawings 5", size: "22 \u00d7 30", pixelWidth: 328, pixelHeight: 360},
        {image: "drawings-06.jpg", thumbAlt: "fire lines", title: "Drawings 6", size: "22 \u00d7 30", pixelWidth: 359, pixelHeight: 360},
        {image: "drawings-07.jpg", thumbAlt: "root lines", title: "Drawings 7", size: "22 \u00d7 30", pixelWidth: 360, pixelHeight: 360},
        {image: "drawings-08.jpg", thumbAlt: "root lines", title: "Drawings 8", size: "22 \u00d7 30", pixelWidth: 241, pixelHeight: 360},
        {image: "drawings-09.jpg", thumbAlt: "root lines", title: "Drawings 9", size: "22 \u00d7 30", pixelWidth: 260, pixelHeight: 360},
    ],
    piecesColumns: 9,
    statementTitle: "Drawings",
    statement: {
        leftColumn: [
            "Root Fungi are an inspiring phenomenon and the stimulus for these drawings. Mycorrhizae are a type of " +
            "fungi that have a mutual symbiosis with the root system of almost every plant and tree on the planet. " +
            "The fungi fit like a glove over plant roots. About 90% of plants and trees obtain their mineral nutrients " +
            "with the help of these fungi. In return, plants provide sugars from their leaves to the fungi. This " +
            "relationship started 400 million years ago when the first land plants originated. The interaction between " +
            "the first struggling, one-celled land plant and the fungi is said to be responsible for the plant’s " +
            "ultimate viability.",
            "This ongoing and mutualistic relationship between plants and fungi is literally the underpinning for " +
            "the success of plant life on earth. The infinite numbers of microscopic networks are inconceivable. " +
            "They provide vitality, energy, and life indiscriminately.",
        ],
        rightColumn: [
            "The prints that came from this inspiration, express the kinetic, pervasive, power of lines and " +
            "networks....the life force, the animation, the vibration, the potential power of connection. " +
            "The “line bodies” dance, move, lie, disturb, sustain, collect and connect.",
            "My lines are an exploration of movement and energy. They seem alive. I am mystified by the sheer " +
            "existence of these networks underground and aim to symbolize their activity, movement, and strength " +
            "through these images.",
        ],
    },
};

export default Drawings;
